import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators,FormGroupDirective} from '@angular/forms';
import { ApiService } from '../api.service';
import { ObservablesService } from '../observables.service';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-role-master',
  templateUrl: './role-master.component.html',
  styleUrls: ['./role-master.component.scss']
})
export class RoleMasterComponent implements OnInit {
  roles:any=[];
  editItemId:any;
  editRoleStatus:boolean = false
  roleExistStatus:boolean = false
  selected_role_id:any=''
  dataForm: FormGroup;
  permissionForm: FormGroup;
  loggedUserInfo:any=[]
  h_level:any=[]
  closeResult: string;
  adminPattern: any = /^(?!ADMIN$).*$/i;
  constructor(private modalService: NgbModal,private observables:ObservablesService, private formBuilder: FormBuilder,private api:ApiService) { }

  ngOnInit() {
    this.api.getLoggedUserInfo().then((res:any)=>{
      if(res.data.length > 0){
        this.loggedUserInfo = res.data[0];
        this.getRoles();
        this.h_level = Array(res.data[0].h_level).fill(0).map((x,i)=>i+1);
      }else{
        this.api.logOut()
      }
    })

    this.dataForm= this.formBuilder.group({
      level:[null,Validators.required],
      role:[null,Validators.compose([Validators.required,Validators.pattern(this.adminPattern)])],
      is_last_level:[false]
    });
    this.permissionForm= this.formBuilder.group({
      item_all:[false,Validators.required],
      item_view_status:[false,Validators.required],
      item_create_status:[false,Validators.required],
      item_edit_status:[false,Validators.required],
      item_delete_status:[false,Validators.required],
      party_all:[false,Validators.required],
      party_view_status:[false,Validators.required],
      party_create_status:[false,Validators.required],
      party_edit_status:[false,Validators.required],
      party_delete_status:[false,Validators.required],
      slip_all:[false,Validators.required],
      slip_view_status:[false,Validators.required],
      slip_create_status:[false,Validators.required],
      slip_edit_status:[false,Validators.required],
      slip_delete_status:[false,Validators.required],
      invoice_all:[false,Validators.required],
      invoice_view_status:[false,Validators.required],
      invoice_create_status:[false,Validators.required],
      invoice_edit_status:[false,Validators.required],
      invoice_delete_status:[false,Validators.required],
      user_all:[false,Validators.required],
      user_view_status:[false,Validators.required],
      user_create_status:[false,Validators.required],
      user_edit_status:[false,Validators.required],
      user_delete_status:[false,Validators.required],
      role_all:[false,Validators.required],
      role_view_status:[false,Validators.required],
      role_create_status:[false,Validators.required],
      role_edit_status:[false,Validators.required],
      role_delete_status:[false,Validators.required]
    });

  }

  setPermissions(content,roleData){
    // console.log("roleData=",roleData)
    this.selected_role_id = roleData.id;
    this.permissionForm.patchValue({
      item_all:null,
      item_view_status:roleData.item_view_status,
      item_create_status:roleData.item_create_status,
      item_edit_status:roleData.item_edit_status,
      item_delete_status:roleData.item_delete_status,
      party_all:null,
      party_view_status:roleData.party_view_status,
      party_create_status:roleData.party_create_status,
      party_edit_status:roleData.party_edit_status,
      party_delete_status:roleData.party_delete_status,
      slip_all:null,
      slip_view_status:roleData.slip_view_status,
      slip_create_status:roleData.slip_create_status,
      slip_edit_status:roleData.slip_edit_status,
      slip_delete_status:roleData.slip_delete_status,
      invoice_all:null,
      invoice_view_status:roleData.invoice_view_status,
      invoice_create_status:roleData.invoice_create_status,
      invoice_edit_status:roleData.invoice_edit_status,
      invoice_delete_status:roleData.invoice_delete_status,
      user_all:null,
      user_view_status:roleData.user_view_status,
      user_create_status:roleData.user_create_status,
      user_edit_status:roleData.user_edit_status,
      user_delete_status:roleData.user_delete_status,
      role_all:null,
      role_view_status:roleData.role_view_status,
      role_create_status:roleData.role_create_status,
      role_edit_status:roleData.role_edit_status,
      role_delete_status:roleData.role_delete_status
    });
    this.openModal(content,roleData)
  }

  selectLevel(event){
    // console.log('event==',event)
    this.roleExistStatus = false
    this.roles.filter((item)=>{
      if(this.editRoleStatus){
        if(item.level == event.value && item.id != this.editItemId){
          this.roleExistStatus = true
        }

      }else{

        if(item.level == event.value){
          this.roleExistStatus = true
        }
      }
    })
  }

  getRoles(){
    this.api.send('findDb',{
      table:"roles",
      conditions:[{business_id:this.loggedUserInfo.business_id}]
    }).then((res:any)=>{
      this.roles = res.data;
    })
  }

  checkLastLevel(event,operation,role_id=null){
    // console.log(event);
    return new Promise((resolve)=>{
      let foundStatus = false;
      for(let i=0;i<this.roles.length;i++){
        if(operation =='add'){

          if(this.roles[i].is_last_level == 1){
            foundStatus = true;
          }
        }else{
          if(this.roles[i].is_last_level == 1 && this.roles[i].id != role_id){
            foundStatus = true;
          }
        }

        if(i==this.roles.length - 1){
          resolve(foundStatus)
        }
      }
    })

  }

  cancel(){
    this.editRoleStatus = false;
    this.dataForm.reset()
  }

  submitData(value,formDirective:FormGroupDirective,action,content){
    if(!this.roleExistStatus){

      if(action == 'add'){
        if(this.loggedUserInfo.h_level == this.roles.length){
          this.observables.showToastMessage({type:1,message:' You can\'t add more roles, because your business heirarchy level limit is '+this.loggedUserInfo.h_level+'.'});
        }else{
          if(value.is_last_level){
            this.checkLastLevel(value,'add').then((res:any)=>{
              if(res){
                this.observables.showToastMessage({type:1,message:'Last level Role is Already Exists..'});
              }else{
                this.saveData(value,formDirective,content)
              }
            })
          }else{
            this.saveData(value,formDirective,content)
          }
        }
      }else{

        if(value.is_last_level){
          this.checkLastLevel(value,'edit',this.editItemId).then((res:any)=>{
            if(res){
              this.observables.showToastMessage({type:1,message:'Last level Role is Already Exists..'});
            }else{
              this.updateData(value,formDirective,content)
            }
          })
        }else{
          this.updateData(value,formDirective,content)
        }
      }
    }

  }

  updateData(value,formDirective,content){
    this.api.send("updateDb",{
      table:'roles',
      data:{
        business_id:this.loggedUserInfo.business_id,
        role:value.role,
        level:value.level,
        is_last_level:value.is_last_level?1:0
      },
      conditions:[{
        id:this.editItemId
      }]
    }).then((result:any)=>{
      if(result.data.affectedRows){

        formDirective.resetForm();
        this.dataForm.reset();
        this.editItemId = "";
        this.editRoleStatus = false;
        this.observables.showToastMessage({type:0,message: 'Role Updated..'});
        this.getRoles()
      }else{
        this.observables.showToastMessage({type:1,message:'Role not updated..'});
      }

    })
  }

  saveData(value,formDirective,content){
    this.api.send("insertDb",{
      table:'roles',
      data:{
        business_id:this.loggedUserInfo.business_id,
        role:value.role,
        level:value.level,
        is_last_level:value.is_last_level?1:0
      }
    }).then((result:any)=>{
      if(result.data.affectedRows){
        formDirective.resetForm();
        this.dataForm.reset();
        if(result.data.affectedRows){
          this.dataForm.reset()
          this.selected_role_id = result.data.insertId;
          this.openModal(content, value)
          this.observables.showToastMessage({type:0,message: 'Role saved..'});
          this.getRoles()
        }else{
          this.observables.showToastMessage({type:1,message:'Role not saved..'});
        }

      }
    })
  }

  openModal(content,roleData){
    this.modalService.open(content,  {size: 'lg', windowClass: 'modal-xl'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;

    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  statusChange(event,action,column){

    if(column == 'item'){
      if(action == 'all' && event.checked){
        this.permissionForm.patchValue({item_view_status:true,item_create_status:true,item_edit_status:true,item_delete_status:true})
      }else if(action == 'all' && !event.checked){
        this.permissionForm.patchValue({item_view_status:false,item_create_status:false,item_edit_status:false,item_delete_status:false})
      }else{
        this.permissionForm.patchValue({item_all:false})
      }
    }else if(column == 'party'){
      if(action == 'all' && event.checked){
        this.permissionForm.patchValue({party_view_status:true,party_create_status:true,party_edit_status:true,party_delete_status:true})
      }else if(action == 'all' && !event.checked){
        this.permissionForm.patchValue({party_view_status:false,party_create_status:false,party_edit_status:false,party_delete_status:false})
      }else{
        this.permissionForm.patchValue({party_all:false})
      }
    }else if(column == 'slip'){
      if(action == 'all' && event.checked){
        this.permissionForm.patchValue({slip_view_status:true,slip_create_status:true,slip_edit_status:true,slip_delete_status:true})
      }else if(action == 'all' && !event.checked){
        this.permissionForm.patchValue({slip_view_status:false,slip_create_status:false,slip_edit_status:false,slip_delete_status:false})
      }else{
        this.permissionForm.patchValue({slip_all:false})
      }
    }else if(column =='invoice'){
      if(action == 'all' && event.checked){
        this.permissionForm.patchValue({invoice_view_status:true,invoice_create_status:true,invoice_edit_status:true,invoice_delete_status:true})
      }else if(action == 'all' && !event.checked){
        this.permissionForm.patchValue({invoice_view_status:false,invoice_create_status:false,invoice_edit_status:false,invoice_delete_status:false})
      }else{
        this.permissionForm.patchValue({invoice_all:false})
      }
    }else if(column =='user'){

      if(action == 'all' && event.checked){
        this.permissionForm.patchValue({user_view_status:true,user_create_status:true,user_edit_status:true,user_delete_status:true})
      }else if(action == 'all' && !event.checked){
        this.permissionForm.patchValue({user_view_status:false,user_create_status:false,user_edit_status:false,user_delete_status:false})
      }else{
        this.permissionForm.patchValue({user_all:false})
      }
    }else if(column =='role'){
      if(action == 'all' && event.checked){
        this.permissionForm.patchValue({role_view_status:true,role_create_status:true,role_edit_status:true,role_delete_status:true})
      }else if(action == 'all' && !event.checked){
        this.permissionForm.patchValue({role_view_status:false,role_create_status:false,role_edit_status:false,role_delete_status:false})
      }else{
        this.permissionForm.patchValue({role_all:false})
      }
    }


  }

private getDismissReason(reason: any): string {

  if (reason === ModalDismissReasons.ESC) {
    return 'by pressing ESC';
  } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
    return 'by clicking on a backdrop';
  } else {
    return  `with: ${reason}`;
  }
}


save(value){
  // console.log("value==",value)
  if(confirm("Please Verify again the Applied Permssion..")){

    this.api.send("updateDb",{
      table:'roles',
      data:{
        invoice_view_status:(value.invoice_view_status)?1:0,
        invoice_create_status:(value.invoice_create_status)?1:0,
        invoice_delete_status:(value.invoice_delete_status)?1:0,
        invoice_edit_status:(value.invoice_edit_status)?1:0,
        item_view_status:(value.item_view_status)?1:0,
        item_create_status:(value.item_create_status)?1:0,
        item_delete_status:(value.item_delete_status)?1:0,
        item_edit_status:(value.item_edit_status)?1:0,
        party_view_status:(value.party_view_status)?1:0,
        party_create_status:(value.party_create_status)?1:0,
        party_delete_status:(value.party_delete_status)?1:0,
        party_edit_status:(value.party_edit_status)?1:0,
        slip_view_status:(value.slip_view_status)?1:0,
        slip_create_status:(value.slip_create_status)?1:0,
        slip_delete_status:(value.slip_delete_status)?1:0,
        slip_edit_status:(value.slip_edit_status)?1:0,
        user_view_status:(value.user_view_status)?1:0,
        user_create_status:(value.user_create_status)?1:0,
        user_delete_status:(value.user_delete_status)?1:0,
        user_edit_status:(value.user_edit_status)?1:0,
        role_view_status:(value.role_view_status)?1:0,
        role_create_status:(value.role_create_status)?1:0,
        role_delete_status:(value.role_delete_status)?1:0,
        role_edit_status:(value.role_edit_status)?1:0
      },
      conditions:[{id:this.selected_role_id}]
    }).then((res:any)=>{
      if(res.data.affectedRows){
        this.permissionForm.reset()
        this.modalService.dismissAll();
        this.getRoles();
        this.observables.showToastMessage({type:0,message:'Permissions saved..'});
      }else{
        this.observables.showToastMessage({type:1,message:'Permissions not saved..'});
      }
    })
  }
}

  deleteItem(id){
    if(confirm("Are you sure to delete Role?")){

      if(confirm("Related Data will be lost permanently, Please Confirm.")){

        this.api.send("deleteDb",{
          table:"roles",
          conditions:[{id:id}]
        }).then((result:any)=>{

          if(result.data.affectedRows){

            this.getRoles();
            this.cancel()
          }
        })
      }

    }
  }

  editItem(item){
    this.editItemId = item.id;
    this.editRoleStatus = true;
    this.dataForm.patchValue({
      level:item.level,
      role:item.role,
      is_last_level:item.is_last_level
    });

  }

}
